import React from "react";
import { Box, Typography, Card, CardContent, Chip, Button } from "@mui/material";
import { CheckCircle as BilledIcon, AttachMoney as RevenueIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

const BilledSchools = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <BilledIcon sx={{ fontSize: 40, color: "success.main" }} />
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Billed Schools
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Active paid schools generating revenue
            </Typography>
          </Box>
        </Box>
        <Card sx={{ mb: 3, bgcolor: "success.light", color: "success.contrastText" }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Revenue Overview
                </Typography>
                <Typography variant="body2">
                  Track revenue from active subscriptions and identify upsell opportunities.
                </Typography>
              </Box>
              <Button variant="contained" sx={{ bgcolor: "white", color: "success.main", "&:hover": { bgcolor: "grey.100" } }}>
                View Revenue Report
              </Button>
            </Box>
          </CardContent>
        </Card>
        <Typography variant="body1" sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
          Billed schools list - Filtered view of Schools component
        </Typography>
      </motion.div>
    </Box>
  );
};

export default BilledSchools;

